module.exports = __webpack_public_path__ + "img/32.92fce4fd.jpg";